"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MIN_SUCCESS_HTTP_CODE = exports.MAX_SUCCESS_HTTP_CODE = void 0;
const MAX_SUCCESS_HTTP_CODE = exports.MAX_SUCCESS_HTTP_CODE = 299;
const MIN_SUCCESS_HTTP_CODE = exports.MIN_SUCCESS_HTTP_CODE = 200;
